const STEPS = [
  {
    n: '01',
    title: 'Registry Entry',
    desc: 'Provide your high-precision birth details (date, time, location) to initiate the cosmic synchronization process.',
    icon: (
      <>
        <rect width="8" height="4" x="8" y="2" rx="1" ry="1" />
        <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
        <path d="M12 11h4" />
        <path d="M12 16h4" />
        <path d="M8 11h.01" />
        <path d="M8 16h.01" />
      </>
    ),
  },
  {
    n: '02',
    title: 'Clinical Analysis',
    desc: 'Maharaj Ji conducts a meticulous audit of your planetary nodes, identifying karmic debts and future opportunities.',
    icon: (
      <>
        <circle cx="11" cy="11" r="8" />
        <path d="m21 21-4.3-4.3" />
      </>
    ),
  },
  {
    n: '03',
    title: 'Divine Session',
    desc: 'Engage in a deep spiritual consultation where your life path is decoded with absolute clarity and precision.',
    icon: <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />,
  },
  {
    n: '04',
    title: 'Remedial Sync',
    desc: 'Receive customized Vedic remedies—gemstones, mantras, or Vastu adjustments—to harmonize your energy with the universe.',
    icon: (
      <>
        <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
        <path d="m9 12 2 2 4-4" />
      </>
    ),
  },
]

export default function ProcessSection() {
  return (
    <section className="py-24 bg-white border-y border-border/40 overflow-hidden">
      <div className="container px-6 mx-auto">
        <div className="max-w-3xl w-full mx-auto text-center mb-16">
          <span className="text-secondary text-[10px] tracking-[0.3em] uppercase mb-4 block font-normal">The Protocol</span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-cinzel text-primary leading-tight mb-6 font-normal uppercase">
            Our Consultation <span className="text-secondary">Process</span>
          </h2>
          <p className="text-primary/55 leading-relaxed text-base font-normal uppercase">
            A clinical spiritual sequence designed to ensure 100% accuracy in your life path diagnostic.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 relative">
          <div className="hidden lg:block absolute top-12 left-0 w-full h-px border-t border-dashed border-primary/10 -z-0" />

          {STEPS.map((step) => (
            <div key={step.n} className="relative z-10 space-y-6 text-center group p-6 rounded-3xl transition-all duration-500 hover:bg-[#991b1b]">
              <div className="w-16 h-16 mx-auto rounded-2xl bg-white border border-primary/10 flex items-center justify-center text-primary group-hover:bg-white group-hover:text-[#991b1b] transition-all duration-500 shadow-xl shadow-primary/5">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-8 h-8">
                  {step.icon}
                </svg>
              </div>
              <div className="space-y-2">
                <h3 className="text-xl font-cinzel text-primary group-hover:text-white transition-colors">{step.title}</h3>
                <p className="text-sm text-primary/60 leading-relaxed group-hover:text-white/90">{step.desc}</p>
              </div>
              <div className="flex flex-col items-center gap-2">
                <div className="h-4 w-px bg-secondary/40" />
                <div className="text-[10px] font-mono font-bold text-secondary uppercase tracking-[0.4em] group-hover:text-white">Step {step.n}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
